import { render, staticRenderFns } from "./GraficoProponente.vue?vue&type=template&id=091a1379&"
import script from "./GraficoProponente.vue?vue&type=script&lang=js&"
export * from "./GraficoProponente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports